import React from 'react';
import styled from 'styled-components';
import FroalaInput from '@app/react-common/FroalaInput';
import { Modal } from 'components';

type COVID19TemplateModalProps = {
  handleSave: () => void;
  title: string;
  template: string;
  show: boolean;
  preview: boolean;
  onCancel: () => void;
  handleTemplateChange: (newValue: string) => void;
  Wrapper: React.ComponentType;
};

const StyledModalBody = styled.div`
  padding: 10px;
`;

const COVID19TemplateModal = ({
  template,
  show,
  title,
  preview,
  handleSave,
  onCancel,
  handleTemplateChange,
  Wrapper,
}: COVID19TemplateModalProps) => (
    <Modal
      data-cy="modal-popup"
      open={show}
      onCancel={() => onCancel()}
      okText="Save"
      onOk={() => handleSave()}
      width="85%"
      style={{ transform: 'translateY(-7.5%)', maxWidth: '1200px' }}
      title={title}
    >
      <StyledModalBody>
        <div className={preview ? 'previewArea' : ''}>
          <Wrapper>
            {preview ? (
              <div dangerouslySetInnerHTML={{ __html: template }}></div>
            ) : (
              <FroalaInput
                config={{
                  height: 500,
                }}
                onModelChange={(newValue: string) =>
                  handleTemplateChange(newValue)
                }
                model={template}
              />
            )}
          </Wrapper>
        </div>
      </StyledModalBody>
    </Modal>
  );

export default COVID19TemplateModal;
